<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="services-page">
    <!-- HERO -->
    <section class="page-hero">
      <div class="page-hero-inner">
        <div class="section-label">Our Services</div>
        <h1 class="page-title">四大核心服務</h1>
        <p class="page-sub">從個人療癒到企業綠化，我們提供全方位的植栽服務</p>
      </div>
    </section>

    <!-- SERVICES -->
    <section class="services-section">
      <div class="services-inner">
        <div v-if="loading" class="loading-wrap">
          <div class="loading-spinner"></div>
          <p>載入服務中...</p>
        </div>
        <div v-else-if="services.length > 0" class="services-grid">
          <div v-for="s in services" :key="s.id" class="service-card">
            <div class="service-icon">{{ s.emoji }}</div>
            <div class="service-name">{{ s.name }}</div>
            <div class="service-desc">{{ s.description }}</div>
            <router-link to="/contact" class="service-btn"
              >了解更多</router-link
            >
          </div>
        </div>
        <div v-else class="no-data">
          <p>暫無服務資料</p>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="services-cta">
      <div class="cta-inner">
        <h2>想了解更多服務細節？</h2>
        <p>歡迎聯絡我們，我們將為您量身打造最適合的植栽方案</p>
        <router-link to="/contact" class="btn-primary">立即諮詢</router-link>
      </div>
    </section>

    <!-- FOOTER -->
    <footer class="footer">
      <div class="footer-inner">
        <p>© 2026 綠憩植研 Green Rich Geam. All rights reserved.</p>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";

const services = ref([]);
const loading = ref(true);

const loadServices = async () => {
  try {
    const response = await axios.get("/services");
    services.value = response.data;
  } catch (error) {
    console.error("載入服務失敗:", error);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  loadServices();
});
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.services-page {
  font-family: "Noto Sans TC", "Microsoft JhengHei", sans-serif;
  background: #f7f5ef;
  color: #1c2b1a;
}

/* HERO */
.page-hero {
  background: linear-gradient(135deg, #2d5016 0%, #4e7b4f 100%);
  color: white;
  padding: 80px 40px;
  text-align: center;
}

.page-hero-inner {
  max-width: 600px;
  margin: 0 auto;
}

.section-label {
  font-size: 12px;
  letter-spacing: 3px;
  text-transform: uppercase;
  opacity: 0.7;
  margin-bottom: 16px;
}

.page-title {
  font-size: 3em;
  font-weight: 600;
  margin-bottom: 16px;
}

.page-sub {
  font-size: 1.1em;
  opacity: 0.85;
  line-height: 1.7;
}

/* SERVICES */
.services-section {
  max-width: 1200px;
  margin: 80px auto;
  padding: 0 40px;
}

.services-inner {
  width: 100%;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 30px;
}

.service-card {
  background: white;
  border-radius: 16px;
  padding: 40px 30px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
}

.service-icon {
  font-size: 60px;
  margin-bottom: 20px;
}

.service-name {
  font-size: 20px;
  font-weight: 600;
  color: #1c2b1a;
  margin-bottom: 16px;
}

.service-desc {
  font-size: 14px;
  color: #6b7f68;
  line-height: 1.7;
  margin-bottom: 24px;
  flex: 1;
}

.service-btn {
  padding: 10px 24px;
  background: #eaf2e0;
  color: #4e7b4f;
  border-radius: 20px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s;
}

.service-btn:hover {
  background: #4e7b4f;
  color: white;
}

/* LOADING */
.loading-wrap {
  text-align: center;
  padding: 80px 20px;
  color: #6b7f68;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #eaf2e0;
  border-top: 3px solid #4e7b4f;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.no-data {
  text-align: center;
  padding: 80px 20px;
  color: #9baa97;
  font-size: 18px;
}

/* CTA */
.services-cta {
  background: linear-gradient(135deg, #2d5016 0%, #4e7b4f 100%);
  color: white;
  padding: 80px 40px;
  text-align: center;
  margin-top: 40px;
}

.cta-inner {
  max-width: 500px;
  margin: 0 auto;
}

.cta-inner h2 {
  font-size: 2em;
  margin-bottom: 12px;
}

.cta-inner p {
  opacity: 0.85;
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 1.7;
}

.btn-primary {
  padding: 14px 40px;
  background: white;
  color: #4e7b4f;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s;
  display: inline-block;
  font-weight: 600;
}

.btn-primary:hover {
  background: #eaf2e0;
  transform: translateY(-2px);
}

/* FOOTER */
.footer {
  background: #1c2b1a;
  color: #9baa97;
  text-align: center;
  padding: 40px;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
}

/* Responsive */
@media (max-width: 768px) {
  .page-title {
    font-size: 2em;
  }

  .services-section {
    margin: 40px auto;
    padding: 0 20px;
  }

  .services-grid {
    grid-template-columns: 1fr;
  }
}
</style>
